import React, { useContext, useEffect } from "react";

import { ThemeContext } from "../../../context/ThemeContext";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import DropdownSVG from "./components/DropdownSVG";
import { useState } from "react";
import { appointmentsJSON, weekDaysJSON } from "../../../store/json/appointments";





const MainDashboard = () => {
  const { changeBackground } = useContext(ThemeContext);
  const appointments=appointmentsJSON
  const weekDays=weekDaysJSON

  const [appointmentsList, setAppointmentsList] = useState(appointments)

  const [dropdownDefaultValue, setDropdownDefaultValue] = useState('Todas')



  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
  }, []);


  function filterAppointments(status){
    setDropdownDefaultValue(status.toUpperCase())
    if(status=="todas"){
      setAppointmentsList(appointments)

      return
    }
    let filteredAppointments=appointments.filter((app)=>app.status==status)
    console.log(filteredAppointments)
    setAppointmentsList(filteredAppointments)
  }

  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <div className="owl-next" onClick={onClick} style={{ zIndex: 99 }}>
        <i className="fa fa-caret-right" />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <div
        className="owl-prev disabled"
        onClick={onClick}
        style={{ zIndex: 99 }}
      >
        <i className="fa fa-caret-left" />
      </div>
    );
  }

  const settings = {
    focusOnSelect: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 500,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1599,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="row">
        <div className="col-xl-6 col-xxl-6">
          <div className="row">
            <div className="col-xl-12">
              <div className="card plan-list">
                <div className="card-header d-sm-flex d-block pb-0 border-0">
                  <div className="me-auto pe-3">
                    <h4 className="text-black fs-20">Próxima consulta</h4>
                    <p className="fs-13 mb-0 text-black">
                      La consulta va a empezar en 3 días
                    </p>
                  </div>
                </div>

                <div className="card-body">
                  <div className="d-flex px-3 pt-3 list-row flex-wrap align-items-center mb-2">
                    <div className="list-icon me-3 mb-3">
                      <p className="fs-24 text-primary mb-0 mt-2">
                        {new Date(appointments[0].dateTime).getDate()}
                      </p>
                      <span className="fs-14 text-primary">
                        {weekDays[
                          new Date(appointments[0].dateTime).getDay()
                        ].slice(0, 3)}
                      </span>
                    </div>
                    <div className="col mb-3">
                      <h4 className="fs-20 ">
                        <Link to="/workout-statistic" className="text-black">
                          {appointments[0].client.clientName}
                        </Link>
                      </h4>
                      <span className="text-success font-w600">
                        {appointments[0].status.toUpperCase()}
                      </span>
                      <h4 className="text-info ms-2 font-w500">
                        {appointments[0].dateTime.split("T")[1].slice(0, 5)}
                      </h4>
                    </div>

                    <Link
                      to={`/appointment/${appointments[0].id}`}
                      className="btn mb-3 btn-outline-primary rounded me-3"
                    >
                      <i className="las la-caret-right scale-2 me-3" />
                      Iniciar Consulta
                    </Link>

                    <Dropdown className="dropdown mb-3">
                      <Dropdown.Toggle
                        as="button"
                        variant=""
                        className="btn rounded border-light icon-false"
                      >
                        <DropdownSVG></DropdownSVG>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu-right">
                        <Dropdown.Item>Terminar consulta</Dropdown.Item>
                        <Dropdown.Item>Consultar perfil</Dropdown.Item>
                        <Dropdown.Item>Cambiar la fecha</Dropdown.Item>
                        <Dropdown.Item>Cancelar la consulta</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    
                  </div>
                </div>

                {/* ================================================================================ */}
                {/* Empieza Div de cada cita */}

                {/* ================================================================================ */}
                {/* Termina Div de cada cita */}
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-6 col-xxl-6">
          <div className="row">
            <div className="col-xl-12">
              <div className="card plan-list">
                <div className="card-header d-sm-flex d-block pb-0 border-0">
                  <div className="me-auto pe-3">
                    <h4 className="text-black fs-20">Proximas consultas</h4>
                    <p className="fs-13 mb-0 text-black">
                      Ve tus próximas consultas y clientes
                    </p>
                  </div>
                  {/* <Link
                    to="/workout-statistic"
                    className="btn rounded text-black border border-light me-4"
                  >
                    <svg
                      className="me-2 filter"
                      width={25}
                      height={24}
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.31615 6H14.4744C14.4744 6.53043 14.6882 7.03914 15.0686 7.41421C15.4491 7.78929 15.9651 8 16.5032 8H18.532C19.07 8 19.5861 7.78929 19.9665 7.41421C20.347 7.03914 20.5607 6.53043 20.5607 6H21.5751C21.8442 6 22.1022 5.89464 22.2924 5.70711C22.4827 5.51957 22.5895 5.26522 22.5895 5C22.5895 4.73478 22.4827 4.48043 22.2924 4.29289C22.1022 4.10536 21.8442 4 21.5751 4H20.5607C20.5607 3.46957 20.347 2.96086 19.9665 2.58579C19.5861 2.21071 19.07 2 18.532 2H16.5032C15.9651 2 15.4491 2.21071 15.0686 2.58579C14.6882 2.96086 14.4744 3.46957 14.4744 4H3.31615C3.04711 4 2.7891 4.10536 2.59887 4.29289C2.40863 4.48043 2.30176 4.73478 2.30176 5C2.30176 5.26522 2.40863 5.51957 2.59887 5.70711C2.7891 5.89464 3.04711 6 3.31615 6ZM16.5032 4H18.532V5V6H16.5032V4ZM21.5751 11H12.4456C12.4456 10.4696 12.2319 9.96086 11.8514 9.58579C11.471 9.21071 10.9549 9 10.4169 9H8.38809C7.85002 9 7.334 9.21071 6.95353 9.58579C6.57306 9.96086 6.35931 10.4696 6.35931 11H3.31615C3.04711 11 2.7891 11.1054 2.59887 11.2929C2.40863 11.4804 2.30176 11.7348 2.30176 12C2.30176 12.2652 2.40863 12.5196 2.59887 12.7071C2.7891 12.8946 3.04711 13 3.31615 13H6.35931C6.35931 13.5304 6.57306 14.0391 6.95353 14.4142C7.334 14.7893 7.85002 15 8.38809 15H10.4169C10.9549 15 11.471 14.7893 11.8514 14.4142C12.2319 14.0391 12.4456 13.5304 12.4456 13H21.5751C21.8442 13 22.1022 12.8946 22.2924 12.7071C22.4827 12.5196 22.5895 12.2652 22.5895 12C22.5895 11.7348 22.4827 11.4804 22.2924 11.2929C22.1022 11.1054 21.8442 11 21.5751 11ZM8.38809 13V11H10.4169V12V13H8.38809ZM21.5751 18H18.532C18.532 17.4696 18.3182 16.9609 17.9378 16.5858C17.5573 16.2107 17.0413 16 16.5032 16H14.4744C13.9364 16 13.4203 16.2107 13.0399 16.5858C12.6594 16.9609 12.4456 17.4696 12.4456 18H3.31615C3.04711 18 2.7891 18.1054 2.59887 18.2929C2.40863 18.4804 2.30176 18.7348 2.30176 19C2.30176 19.2652 2.40863 19.5196 2.59887 19.7071C2.7891 19.8946 3.04711 20 3.31615 20H12.4456C12.4456 20.5304 12.6594 21.0391 13.0399 21.4142C13.4203 21.7893 13.9364 22 14.4744 22H16.5032C17.0413 22 17.5573 21.7893 17.9378 21.4142C18.3182 21.0391 18.532 20.5304 18.532 20H21.5751C21.8442 20 22.1022 19.8946 22.2924 19.7071C22.4827 19.5196 22.5895 19.2652 22.5895 19C22.5895 18.7348 22.4827 18.4804 22.2924 18.2929C22.1022 18.1054 21.8442 18 21.5751 18ZM14.4744 20V18H16.5032V19V20H14.4744Z"
                        fill="black"
                      />
                    </svg>
                    Filter
                  </Link> */}
                  <Dropdown className="mt-sm-0 mt-3">
                    <Dropdown.Toggle
                      variant=""
                      as="button"
                      className="btn rounded border text-black border-light dropdown-toggle"
                    >
                      {dropdownDefaultValue.toLowerCase().charAt(0).toUpperCase() + dropdownDefaultValue.toLowerCase().slice(1)}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="dropdown-menu-right">
                      {dropdownDefaultValue!="Todas"?<Dropdown.Item onClick={(e)=>filterAppointments("todas")}>Todas</Dropdown.Item>:<></>}
                      <Dropdown.Item onClick={(e)=>filterAppointments("confirmado")}>Confirmado</Dropdown.Item>
                      <Dropdown.Item onClick={(e)=>filterAppointments("sin confirmar")}>Sin Confirmar</Dropdown.Item>
                      <Dropdown.Item onClick={(e)=>filterAppointments("cancelado")}>Cancelado</Dropdown.Item>
                      {/* <Dropdown.Item onClick={(e)=>filterAppointments("finalizada")}>Finalizadas</Dropdown.Item> */}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                <div className="card-body">
                  {/* ================================================================================ */}
                  {/* Empieza Div de cada cita */}

                  {appointmentsList?.map((app, index) => (
                    <div className="d-flex px-3 pt-3 list-row flex-wrap align-items-center mb-2">
                      <div className="list-icon me-3 mb-3">
                        <p className="fs-24 text-primary mb-0 mt-2">
                          {new Date(app.dateTime).getDate()}
                        </p>
                        <span className="fs-14 text-primary">
                          {weekDays[new Date(app.dateTime).getDay()].slice(
                            0,
                            3
                          )}
                        </span>
                      </div>
                      <div className="col mb-3">
                        <h4 className="fs-20 ">
                          <Link to="/workout-statistic" className="text-black">
                            {app.client.clientName}
                          </Link>
                        </h4>
                        <span className="text-warning font-w600">
                          {app.status.toUpperCase()}
                        </span>
                        <h4 className="text-info ms-2 font-w600">
                          {app.dateTime.split("T")[1].slice(0, 5)}
                        </h4>
                      </div>

                      <Link
                        to={"/appointment/"+app.id}
                        className="btn mb-3 btn-outline-primary rounded me-3"
                      >
                        <i className="las la-caret-right scale-2 me-3" />
                        Iniciar Consulta
                      </Link>

                      <Dropdown className="dropdown mb-3">
                        <Dropdown.Toggle
                          as="button"
                          variant=""
                          className="btn rounded border-light icon-false"
                        >
                          <DropdownSVG></DropdownSVG>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu-right">
                          <Dropdown.Item>Terminar consulta</Dropdown.Item>
                          <Dropdown.Item>Consultar perfil</Dropdown.Item>
                          <Dropdown.Item>Cambiar la fecha</Dropdown.Item>
                          <Dropdown.Item>Cancelar la consulta</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                      
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainDashboard;
